import { Entity, Field } from "typegraph";

import { ID } from "common/entities/IEntity";
import Certificate from "./Certificate";

export interface IIssuedCertificateQueryArgs {
	userIds: ID[];
}

@Entity({ many: 'issuedCertificates' })
export class IssuedCertificate {

	@Field()
	public id: number;

	@Field()
	public guid: string;

	@Field()
	public issueDate: string;

	@Field()
	public expiryDate: string;

	@Field()
	public itemName: string;

	@Field({ entity: Certificate })
	public certificate: Certificate;

}



// WEBPACK FOOTER //
// ./src/panels/userCertificates/entities/IssuedCertificate.ts